import { action, makeObservable, observable } from 'mobx';

import { getLocalStorageItem, setLocalStorageItem } from '@/utils/localStorage';

const GROUP_CHATS_KEY = 'navRail.groupChatsByRecency';

class NavRailStore {
  collapsedChatGroups = new Set<string>();
  groupChatsByRecency = getLocalStorageItem(GROUP_CHATS_KEY) === true;

  constructor() {
    makeObservable(this, {
      groupChatsByRecency: observable,
      setGroupChatsByRecency: action,
      collapsedChatGroups: observable,
      toggleChatGroup: action,
    });
  }

  toggleChatGroup(label: string) {
    if (this.collapsedChatGroups.has(label))
      this.collapsedChatGroups.delete(label);
    else this.collapsedChatGroups.add(label);
  }

  setGroupChatsByRecency(group: boolean) {
    this.groupChatsByRecency = group;
    try {
      setLocalStorageItem(GROUP_CHATS_KEY, group);
    } catch {
      return;
    }
  }
}

export const navRailStore = new NavRailStore();
